"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createClient = createClient;
var _routing = require("../../routing.cjs");
var _index = require("../../types/index.cjs");
var _utils = require("../../utils.cjs");
function createClient(api) {
  async function list(options) {
    const {
      search,
      query,
      limit,
      offset,
      sortOrder
    } = options;
    return api.get(_routing.routing.campaignsUrl, {
      query: {
        limit,
        offset,
        search,
        query: _index.Query.stringify(query),
        sort: _index.SortOrder.stringify(sortOrder)
      }
    });
  }
  async function search(options) {
    const {
      search,
      query,
      limit,
      offset,
      sortOrder
    } = options;
    return api.post(_routing.routing.campaignsUrl, {
      payload: {
        limit,
        offset,
        search,
        query,
        sort: _index.SortOrder.stringify(sortOrder)
      }
    });
  }
  async function get(id) {
    return api.get(`${_routing.routing.campaignsUrl}/${id}`);
  }
  async function duplicate(id) {
    return api.post(`${_routing.routing.campaignsUrl}/${id}/duplicate`);
  }
  async function doDelete(id) {
    return api.delete(`${_routing.routing.campaignsUrl}/${id}`);
  }
  async function test(id, emails) {
    return api.post(`${_routing.routing.campaignsUrl}/${id}/test`, {
      payload: {
        emails
      }
    });
  }
  async function send(id) {
    return api.post(`${_routing.routing.campaignsUrl}/${id}/send`);
  }
  async function schedule(id, sendAt) {
    const {
      campaign
    } = await api.post(`${_routing.routing.campaignsUrl}/${id}/schedule`, {
      payload: {
        schedule_at: (0, _utils.toIso8601)(sendAt)
      }
    });
    return campaign;
  }
  async function unschedule(id) {
    const {
      campaign
    } = await api.post(`${_routing.routing.campaignsUrl}/${id}/unschedule`);
    return campaign;
  }
  function create(payload) {
    return api.post(_routing.routing.campaignsUrl, {
      payload
    });
  }
  async function update(id, payload) {
    return api.patch(`${_routing.routing.campaignsUrl}/${id}`, {
      payload
    });
  }
  return {
    list,
    search,
    get,
    duplicate,
    test,
    send,
    schedule,
    unschedule,
    create,
    update,
    delete: doDelete
  };
}